<template>
    <div>
      <label v-if="!excludeLabel" :for="label + '-id'">
        {{label || searchFields.join(', ') | unsnake |capitalize}} ({{condition}}):
      </label>
      <input :id="label + '-id'" class="fct-input" :class="{'input-error': error}" name="query" id="search" :placeholder="placeholder || 'Search...'"
             @input="doFilter()" v-model.trim="searchInputText">
      <i v-if="includeIcon" class="fct-admin-icon-magnifier-search"></i>
    </div>
</template>

<script>
  import get from 'lodash.get'
  import { escapeRegExp } from '../../utils/regex'

  let predicateFactoryByCondition = {
    startsWith: (str, fields) => o => fields.some(f => get(o, f).startsWith(str)),
    includes: (str, fields) => o => ~fields.some(f => get(o, f).indexOf(str))
  }

  let queryFactoryByCondition = {
    startsWith: (str, fields) => fields.map(f  => ({[f]: {$regex: '^' +escapeRegExp(str)}})).reduce((a, b) => Object.assign(a, b), {}),
    includes: (str, fields) => fields.map(f  => ({[f]: {$regex: escapeRegExp(str)}})).reduce((a, b) => Object.assign(a, b), {})
  }

  export default {
    props: {
      searchFields: Array,
      placeholder: String,
      includeIcon: Boolean,
      excludeLabel: Boolean, filterManager: Object,
      error: Boolean,
      label: String,
      condition: {
        type: String,
        default: 'includes'
      }},
    data() {
      return {
        searchInputText: '',
      }
    },
    methods: {
      doFilter() {
        this.filterManager.setFilter(this.searchFields.join('-') + '_' + this.condition,
          predicateFactoryByCondition[this.condition](this.searchInputText, this.searchFields),
          queryFactoryByCondition[this.condition](this.searchInputText, this.searchFields))
      }
    },
    mounted() {
      this.filterManager.setFilter('query', o => {
        return this.searchFields.some(f => {
          let fieldValue = get(o, f) || ''

          return [fieldValue].flat().some(v => v.toLowerCase().includes(this.searchInputText.toLowerCase()))
        })
      })
    }
  }
</script>

<style scoped lang="scss">
  .input-error {
    border-color: #eb5757 !important
  }
</style>
